"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 5,
};
exports.default = react_jss_1.createUseStyles({
    hr: function (_a) {
        var theme = _a.theme, size = _a.size, variant = _a.variant, color = _a.color;
        return ({
            border: 0,
            borderTopWidth: theme_1.getSizeValue({ size: size, sizes: exports.sizes }),
            borderTopColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
            borderTopStyle: variant,
            margin: 0,
        });
    },
}, { link: true });
